<template>
	<div class="center_zs fl clearfix">
		<div class="data-box1 box1-back">
			<i class="topL"></i>
			<i class="topR"></i>
			<i class="bottomL"></i>
			<i class="bottomR"></i>
			<div class="data-title">
				<b class="data-title-left">[</b>
				<span>{{$tt('收入概览')}}</span>
				<b class="data-title-right">]</b>
			</div>
			<!--收入概览-->
			<div style="height:33%;">
				<div class="wenti2_bg">
					<table style="width: 100%;height: 100%;" size="small">
						<tbody class="numberDisplay2">
							<tr>
								<td>
									<p>{{$tt('昨日充电收入（元）')}}</p>
									<span>{{OverviewTotal.PreDay.toFixed(2)}}</span>
								</td>
								<td>
									<p>{{$tt('今天充电收入（元）')}}</p>
									<span>{{OverviewTotal.CurrentDay.toFixed(2)}}</span>
								</td>
							</tr>
							<tr>
								<td>
									<p>{{$tt('上月充电收入（元）')}}</p>
									<span>{{OverviewTotal.PreMonth.toFixed(2)}}</span>
								</td>
								<td>
									<p>{{$tt('本月充电收入（元）')}}</p>
									<span>{{OverviewTotal.CurrentMonth.toFixed(2)}}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="wenti3_bg">
				<div id="map" style="position:absolute;height:63%;width: 100%; margin: auto;"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import bus from './bus.js'
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	// import gaodeMap from "../../../js/GaodeMapMethod.js"
	import webapi from '../../../webapi.js'
	export default {
		data() {
			return {
				//总览统计信息
				OverviewTotal: {
					PreDay: 0,
					CurrentDay: 0,
					PreMonth: 0,
					CurrentMonth: 0,
				},
				timer: null,
				//地图数据
				features: [],
			}
		},
		created() {
			this.GetOverviewStations();
			this.getDeviceAndLog()
			this.GetOverviewRevenue()
			// const _this = this;
			this.timer = setInterval(() => {
				this.GetOverviewStations();
				this.getDeviceAndLog()
				this.GetOverviewRevenue()
			}, 60000);
		},
		destroyed() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		},
		activated() {},
		deactivated() {},
		components: {},
		mounted() {
			// gaodeMap.initMap("map", 10, null);
			// //gaodeMap.getSelfMap("深圳");
			// gaodeMap.createMarkeList(this.features)
		},
		computed: {},
		methods: {
			//地图数据
			GetOverviewStations: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Overview/GetOverviewStations", ).then(res => {
					if (res.data.code != 1) {
						console.log(res.data);
						let WorkingNum = 0;
						let StandbyNum = 0;
						let BreakdownNum = 0;
						let OfflineNum = 0;
						res.data.Data.List.forEach(function(item, index, ary) {
							const featuresItem = {
								position: [item.Longitude, item.Latitude],
								type: item.BreakdownNum == 0 ? 'free' : 'fault',
								StationId: item.StationId,
								StationInfo: item
							}
							WorkingNum = WorkingNum + item.WorkingNum;
							StandbyNum = StandbyNum + item.StandbyNum;
							BreakdownNum = BreakdownNum + item.BreakdownNum;
							OfflineNum = OfflineNum + item.OfflineNum;
							_this.features.push(featuresItem);
							//console.log(featuresItem)
						})
						// gaodeMap.createMarkeList(this.features);
						let pieSeries = [{
								value: StandbyNum,
								name: "空闲"
							}, {
								value: WorkingNum,
								name: "充电"
							},
							{
								value: OfflineNum,
								name: "离线"
							},
							{
								value: BreakdownNum,
								name: "故障"
							}
						];
						let totalNum = WorkingNum + StandbyNum + OfflineNum + BreakdownNum;
						const pieSeriesData = {
							pieSeries: pieSeries,
							totalNum: totalNum
						}
						bus.$emit("pieSeries", pieSeriesData)
					}
				})
			},
			closeInfoWindows: function() {
				alert(22222222)
				// gaodeMap.closeInfoWindows()
			},
			//中间  充电信息
			getDeviceAndLog: function() {
				const _this = this;
				_this.logDeviceData = [];
				_this.$axios.post(webapi.base_api_url + "/Overview/GetRecentRecord", {}).then(res => {
					if (res.data.code != 1 && res.data.Data != null) {
						console.log("充电信息")
						console.log(res.data.Data)
						this.logDeviceData = res.data.Data.List
					}
				})
			},
			//收入概览
			GetOverviewRevenue: function() {
				const _this = this;
				_this.logDeviceData = [];
				_this.$axios.post(webapi.base_api_url + "/Overview/GetOverviewRevenue", {}).then(res => {
					console.log("收入概览")
					console.log(res.data.Data)
					_this.OverviewTotal = res.data.Data
				})
			},
		}
	}
</script>

<!-- <script type="text/template" id="mapToolTip">
		<div class="card">
				<div class="card-header">{{ name }}</div>
				<div class="card-body">
						<div class="card d-inline-block">
								<div class="card-body"><span>{{$tt('充电枪总数')}}</span><p class="">{{ staInfo.totalDevNum }}</p></div>
						</div>
						<div class="card d-inline-block">
								<div class="card-body"><span>{{$tt('直流枪数量')}}</span><p class="layui-badge1">{{ staInfo.zhiliuDevNum }}</p></div>
						</div>
						<div class="card d-inline-block">
								<div class="card-body"><span>{{$tt('交流枪数量')}}</span><p class="layui-badge1">{{ staInfo.jiaoliuDevNum }}</p></div>
						</div>
						<hr style="margin:5px 0px; color: rgb(149,184,231)" />
						<div class="card d-inline-block">
								<div class="card-body"><span>{{$tt('充电中数量')}}</span><p class="work-status-charging">{{ staInfo.workingDevNum }}</p></div>
						</div>
						<div class="card d-inline-block">
								<div class="card-body"><span>{{$tt('空闲中数量')}}</span><p class="work-status-standby">{{ staInfo.standbyDevNum }}</p></div>
						</div>
						<div class="card d-inline-block">
								<div class="card-body"><span>{{$tt('故障中数量')}}</span><p class="work-status-fault">{{ staInfo.brokenDevNum }}</p></div>
						</div>
				</div>
		</div>
</script> -->

<style>
	.centerTable .ivu-table {
		background-color: transparent !important;
		color: #55ff00 !important;
		font-size: 50px !important;
	}

	.centerTable .ivu-table td {
		background-color: transparent !important;
	}

	.centerTable .ivu-table .demo-table-info-row td {
		background-color: #262544 !important;
		color: #CCCCCC;
	}

	.centerTable .ivu-table .demo-table-error-row td {
		background-color: #201F3D !important;
		color: #CCCCCC;
	}

	.centerTable .ivu-table th {
		background-color: transparent !important;
	}

	.centerTable .ivu-table-wrapper {
		border: 0px solid #dcdee2 !important;
	}

	.centerTable .ivu-table-border th {
		border-right: 0px solid #e8eaec;
	}

	.centerTable .ivu-table-row-highlight {
		color: #FFFFFF !important;
	}

	.centerTable thead span {
		font-size: 15px;
	}

	.infoMessageStyle {
		background-color: #000000;
		opacity: 1;
	}


	.numberDisplay2 p {
		display: block;
		border-left: 4px solid green;
		padding-left: 2px;
		text-align: left;
		font-size: 15px;
	}

	.numberDisplay2 td {
		width: 33%;
		height: 50%;
	}

	.numberDisplay2 span {
		font-size: 40px;
		color: greenyellow;
		text-align: left;
		color: #83c7e3;
	}

	.numberDisplay4 p {
		display: block;
		border-left: 4px solid green;
		padding-left: 2px;
		text-align: left;
		font-size: 10px;
	}

	.numberDisplay4 td {
		width: 20%;
	}

	.numberDisplay4 span {
		font-size: 20px;
		color: greenyellow;
		text-align: left;
		color: #55ff00;
	}

	.colseIcon {
		display: block;
		float: right;
		width: 30px;
		height: 30px;
		color: red;
		font-size: 25px;
	}

	.work-status-standby {
		color: #7cfc00 !important;
	}

	.work-status-offline {
		color: #c2a400 !important;
	}

	.work-status-fault {
		color: red !important;
	}

	.work-status-charging {
		color: #007cfc !important;
	}

	.d-inline-block {
		display: inline-block !important;
	}

	.card {
		position: relative;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-direction: column;
		flex-direction: column;
		min-width: 0;
		word-wrap: break-word;
		/* background-color: #fff; */
		background-clip: border-box;
		border: 1px solid rgba(0, 0, 0, .125);
		/* border-radius: 0.25rem; */
		background-color: silver;
		border-radius: 8px;
	}

	.card + .card {
		margin: 5px;
	}

	.card-header:first-child {
		border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
	}

	.card-header {
		padding: 8px 10px;
	}

	.card-header {
		/* padding: 0.75rem 1.25rem; */
		margin-bottom: 0;
		background-color: rgba(0, 0, 0, .03);
		border-bottom: 1px solid rgba(0, 0, 0, .125);
		padding: 8px 10px;
	}

	.card-header {}


	.card-body {
		-ms-flex: 1 1 auto;
		flex: 1 1 auto;
		/* padding: 1.25rem; */
		padding: 10px;
	}


	.card-body span {}

	.card-body p {
		font-size: 24px;
		color: teal;
	}
</style>
